import React, { useState } from "react";
import "./CardHashtags.css"
interface HashtagCardProps {
  image: string;
  chineseHashtag: string;
  englishHashtag: string;
  pinyin: string;
  description: string;
  category: string;
  usage: string;
}

const HashtagCard = ({
  image,
  chineseHashtag,
  englishHashtag,
  pinyin,
  description,
  category,
  usage
}: HashtagCardProps) => {
  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = () => {
    setShowDetails((prevState) => !prevState);
  };

  return (
    <div className="card">
      <img src={image} alt={chineseHashtag} />
      <div className="card-content">
        <h2>Chinese: {chineseHashtag}</h2>
        <p>English: {englishHashtag}</p>
        <button
          className="toggle-details"
          onClick={toggleDetails}
        >
          {showDetails ? "Hide Details" : "View Details"}
        </button>
        {showDetails && (
          <div className="card-details">
            <p><strong>Pinyin:</strong> {pinyin}</p>
            <p><strong>Description:</strong> {description}</p>
            <p><strong>Category:</strong> {category}</p>
            <p><strong>Usage:</strong> {usage}</p>
          </div>
        )}
      </div>
    </div>
  );
};

const HashtagList = () => {
  const hashtags = [
    {
      image: "https://img.xhslingo.com/xhs-img/cat_sm.jpg",
      chineseHashtag: "#猫",
      englishHashtag: "#Cat",
      pinyin: "māo",
      description: "Share pictures, videos, and interesting facts about cats.",
      category: "Animals",
      usage: "Used for sharing the daily life and cute moments of cats."
    },
    {
      image: "https://img.xhslingo.com/xhs-img/beauty_sm.jpg",
      chineseHashtag: "#时尚妆容",
      englishHashtag: "#FashionMakeup",
      pinyin: "shíshàng zhuāngróng",
      description: "Showcase trendy makeup looks and beauty styles",
      category: "Beauty",
      usage: "Ideal for makeup artists and beauty influencers"
    },
    {
      image: "https://img.xhslingo.com/xhs-img/cosplay_sm.jpg",
      chineseHashtag: "#角色扮演",
      englishHashtag: "#Cosplay",
      pinyin: "juésè bànyǎn",
      description: "Share cosplay photos, videos, and creation processes.",
      category: "Cosplay",
      usage: "Used for sharing character portrayals and costume making."
    },
    {
      image: "https://img.xhslingo.com/xhs-img/mtf_sm.jpg",
      chineseHashtag: "#MTF",
      englishHashtag: "#MTF",
      pinyin: "MTF",
      description: "Highlight stories and experiences of male-to-female transgender individuals.",
      category: "LGBTQ+",
      usage: "Perfect for sharing journeys, support, and education about the transgender community."
    },
    {
      image: "https://img.xhslingo.com/xhs-img/music_sm.jpg",
      chineseHashtag: "#音乐",
      englishHashtag: "#Music",
      pinyin: "yīnyuè",
      description: "Share various types of music, music recommendations, or live music.",
      category: "Music",
      usage: "Used for sharing favorite music, concerts, and music reviews."
    }
  ];

  return (
    <div className="card-container py-10">
      {hashtags.map((hashtag, index) => (
        <HashtagCard key={index} {...hashtag} />
      ))}
    </div>
  );
};

export default HashtagList;